module.exports = __webpack_public_path__ + "static/illustrations-b0fc4befc796cd8ed3e877eab5f9cd5f.png";